import { render, staticRenderFns } from "./ButtonInputImage.vue?vue&type=template&id=55aeef8e&"
import script from "./ButtonInputImage.vue?vue&type=script&lang=js&"
export * from "./ButtonInputImage.vue?vue&type=script&lang=js&"
import style0 from "./ButtonInputImage.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports